import { initialErrors } from "../Constants/Purchased-history-notes.constants";
import { Types } from "../Constants/Types";
import OrderNoteType from "../Interfaces/purchased-history-notes.interface";

const OrderNotesReducer = (state: OrderNoteType['status'] = { 
        orderNote: undefined,
        orderNotes: [],
        ordersCartLoading: [],
        lorderNotes: false,
        lorderNote: false,
        error: initialErrors
    },
    action: OrderNoteType['action']
    ) => {

    switch (action.type) {

        case Types.PH_FETCH_ORDER_NOTES:
            return {...state, orderNotes: action.payload};

        case Types.PH_FETCH_ORDER_NOTE:
            return {...state, orderNote: action.payload};

        case Types.PH_CREATE_ORDER_NOTE:
            return {...state, orderNotes: [action.payload, ...state.orderNotes]};

        case Types.PH_UPDATE_ORDER_NOTE: 
            return {...state, orderNotes: state.orderNotes.map(orderNote => orderNote._id === action.payload._id ? action.payload : orderNote)};

        case Types.PH_DELETE_ORDER_NOTE: 
            return {...state, orderNotes: state.orderNotes.filter(orderNote => orderNote._id !== action.payload)}

        case Types.PH_START_ORDER_NOTES:
            return {...state, lorderNotes: true};

        case Types.PH_END_ORDER_NOTES:
            return {...state, lorderNotes: false};

        case Types.PH_START_GET_CART_URL:
            return {...state, ordersCartLoading: [...state.ordersCartLoading, action.payload]};

        case Types.PH_END_GET_CART_URL:
            return {...state, ordersCartLoading: state.ordersCartLoading.filter(order => order !== action.payload)}

        case Types.PH_ERROR_ORDER_NOTE:
            return {...state, error: action?.payload ? {...state.error, [action?.field!]: action.payload} : {...state.error, [action?.field!]: null}};

        case Types.PH_RESET_ORDER_NOTE:
            return {...state, error: initialErrors}

        default: 
            return state
    }
}

export default OrderNotesReducer;